import React from 'react';
import { ApolloProvider } from 'react-apollo';

import { ConditionalRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';
import { fg } from '@confluence/feature-gating';
import type { ApolloClient } from 'apollo-client';

interface Props {
	client: ApolloClient<any>;
	children: React.ReactNode;
}

export const GraphqlProvider = ({ client, children }: Props) => {
	return fg('confluence_use_relay_env_provider') ? (
		<ConditionalRelayEnvironmentProvider>{children}</ConditionalRelayEnvironmentProvider>
	) : (
		<ApolloProvider client={client}>{children}</ApolloProvider>
	);
};
